import React from 'react';
import { RadarChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis, Radar, Legend, ResponsiveContainer } from 'recharts';
import { PageAuditResult } from '../types';

interface SEOChartProps {
  pageResults: PageAuditResult[];
}

const SEOChart: React.FC<SEOChartProps> = ({ pageResults }) => {
  const chartData = pageResults[0].results.map(result => ({
    subject: result.name,
    score: result.score,
    fullMark: 10,
  }));

  return (
    <div className="w-full h-64 sm:h-96 mb-6 sm:mb-8 bg-mover-darkest bg-opacity-20 backdrop-blur-md rounded-lg p-2 sm:p-4">
      <ResponsiveContainer width="100%" height="100%">
        <RadarChart cx="50%" cy="50%" outerRadius="80%" data={chartData}>
          <PolarGrid stroke="#30314b" />
          <PolarAngleAxis
            dataKey="subject"
            tick={{ fill: '#f5f2f1', fontSize: '10px' }}
          />
          <PolarRadiusAxis
            angle={30}
            domain={[0, 10]}
            tick={{ fill: '#f5f2f1', fontSize: '10px' }}
          />
          <Radar name="SEO Score" dataKey="score" stroke="#6e45e9" fill="#6e45e9" fillOpacity={0.6} />
          <Legend wrapperStyle={{ color: '#f5f2f1', fontSize: '12px' }} />
        </RadarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default SEOChart;